export default __webpack_public_path__ + "static/media/web-white.59b842a1.png";